// Mock data pour le site ATOM Group

export const testimonials = [
  {
    id: 1,
    name: "Client satisfait",
    location: "Client depuis 10 ans",
    text: "Je connais Joël depuis une dizaine d'années, et je me tourne toujours vers lui quand j'ai besoin de me pencher sur les assurances, les comptes ou d'autres questions financières. Il est disponible, sympathique et réactif, et trouve souvent des solutions adaptées qui répondent à mes besoins. Je le recommande à tous ceux qui ont des questions dans ce domaine.",
    avatar: "https://images.unsplash.com/photo-1594938384824-022767a58e11",
    rating: 5
  },
  {
    id: 2,
    name: "Client satisfait",
    location: "Suisse romande", 
    text: "Joël Ott saura vous accompagner de manière hautement professionnelle à travers toutes les étapes importantes de votre vie, notamment grâce à sa vision globale de votre planification financière. Je peux le recommander sans hésitation !",
    avatar: "https://images.unsplash.com/photo-1709889683644-c088aa8cad6b",
    rating: 5
  },
  {
    id: 3,
    name: "Client satisfait",
    location: "Neuchâtel",
    text: "Conseils parfaitement adaptés à nos besoins financiers. Discrétion, flexibilité et rigueur sont au rendez-vous. Nous avons hâte de refaire appel à ses services dans le futur.",
    avatar: "https://images.unsplash.com/photo-1594938384824-022767a58e11",
    rating: 5
  },
  {
    id: 5,
    name: "Client satisfait",
    location: "Genève",
    text: "Service impeccable pour l'optimisation de mon 3ème pilier. Des explications claires, une disponibilité remarquable et des solutions parfaitement adaptées à ma situation. Je recommande vivement !",
    avatar: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2",
    rating: 5
  },
  {
    id: 6,
    name: "Client satisfait",
    location: "Fribourg",
    text: "En tant qu'indépendant, j'avais besoin de conseils sur ma prévoyance professionnelle. L'approche personnalisée et la compétence ont vraiment répondu à mes attentes. Un vrai partenaire de confiance.",
    avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e",
    rating: 5
  }
];

export const solutions = [
  {
    id: 1,
    title: "Assurances",
    description: "Protection complète pour votre tranquillité d'esprit et celle de votre famille",
    icon: "Shield",
    path: "/assurances"
  },
  {
    id: 2,
    title: "Retraite / Prévoyance",
    description: "Optimisez vos 3 piliers et préparez sereinement votre retraite",
    icon: "PiggyBank",
    path: "/retraite"
  },
  {
    id: 3,
    title: "Fiscalité",
    description: "Optimisation légale de votre situation fiscale",
    icon: "Calculator",
    path: "/fiscalite"
  },
  {
    id: 4,
    title: "Investissements",
    description: "Solutions de placement adaptées à votre profil et objectifs",
    icon: "TrendingUp",
    path: "/investissements"
  },
  {
    id: 5,
    title: "Immobilier",
    description: "Solutions complètes : financement, courtage et accompagnement achat/vente",
    icon: "Home",
    path: "/immobilier"
  },
  {
    id: 6,
    title: "Crédits",
    description: "Accompagnement sur mesure pour vos financements privés",
    icon: "CreditCard",
    path: "/credits-prives"
  },
  {
    id: 7,
    title: "Indépendants et PME",
    description: "Conseil spécialisé pour entrepreneurs et petites entreprises",
    icon: "Building2",
    path: "/pme"
  }
];

export const whyUs = [
  {
    id: 1,
    title: "Indépendance du conseil",
    description: "Nos recommandations reposent sur une analyse globale du marché. Nous proposons les produits les plus adaptés à vos besoins, sans dépendance exclusive à une seule institution."
  },
  {
    id: 2,
    title: "Liberté d'action",
    description: "Nos conseils vous ouvrent toutes les options, mais la décision finale reste toujours entre vos mains."
  },
  {
    id: 3,
    title: "Transparence du conseil",
    description: "Une tarification claire et lisible, sans frais cachés ni commissions dissimulées."
  },
  {
    id: 4,
    title: "Conseils personnalisés",
    description: "Des solutions conçues sur mesure, parfaitement adaptées à votre situation et à vos objectifs."
  }
];

export const simulators = [
  {
    id: 1,
    title: "Intérêts composés",
    description: "Calculez la croissance de vos investissements sur le long terme",
    icon: "TrendingUp"
  },
  {
    id: 2,
    title: "Immobilier",
    description: "Achat vs location et simulation de prêt hypothécaire",
    icon: "Home"
  },
  {
    id: 3,
    title: "Crédit",
    description: "Estimez vos capacités d'emprunt et mensualités",
    icon: "CreditCard"
  },
  {
    id: 4,
    title: "Fiscalité",
    description: "Optimisation des déductions et estimation d'impôts",
    icon: "Receipt"
  },
  {
    id: 5,
    title: "Retraite / 3 piliers",
    description: "Estimation rapide de vos besoins retraite",
    icon: "Calendar"
  },
  {
    id: 6,
    title: "Succession",
    description: "Planification de la transmission de patrimoine",
    icon: "FileText"
  },
  {
    id: 7,
    title: "Optimisation patrimoniale",
    description: "Analyse complète de votre situation financière",
    icon: "Target"
  },
  {
    id: 8,
    title: "Prévoyance professionnelle",
    description: "Calcul des prestations LPP et rachats optimaux",
    icon: "Shield"
  }
];

export const faqData = [
  // GÉNÉRAL
  {
    id: 1,
    question: "ATOM Group SA est-il lié à une banque ou un assureur ?",
    answer: "ATOM Group SA est 100% indépendant financièrement. Nous collaborons avec plus de 50 institutions partenaires via des conventions de courtage, ce qui nous permet de vous conseiller objectivement et de négocier les meilleures conditions pour vous."
  },
  {
    id: 2,
    question: "Vos services sont-ils payants ?",
    answer: "La première analyse est gratuite et sans engagement. Nos honoraires sont transparents et convenus à l'avance selon la complexité de votre dossier."
  },
  {
    id: 3,
    question: "Mes données sont-elles protégées ?",
    answer: "Oui, toutes vos données sont hébergées et sécurisées en Suisse. Nous respectons strictement la confidentialité et la protection des données personnelles."
  },
  {
    id: 4,
    question: "Puis-je transférer mes contrats existants ?",
    answer: "Oui, nous vous accompagnons dans le transfert de vos contrats existants si cela s'avère avantageux pour votre situation."
  },
  {
    id: 5,
    question: "Proposez-vous aussi pour les PME ?",
    answer: "Oui, nous avons des solutions dédiées aux indépendants et PME : prévoyance professionnelle, optimisation fiscale d'entreprise, et couverture des risques."
  },
  
  // 3ÈME PILIER
  {
    id: 6,
    question: "Quelle est la différence entre 3ème pilier 3a et 3b ?",
    answer: "Le 3ème pilier 3a (pilier lié) est déductible fiscalement jusqu'à CHF 7'258 par an (2026) pour les salariés et CHF 36'288 pour les indépendants. Les fonds sont bloqués jusqu'à la retraite (avec exceptions : achat résidence principale, départ Suisse, indépendance). Le 3ème pilier 3b (pilier libre) n'est pas déductible fiscalement mais offre une flexibilité totale : retrait à tout moment, pas de plafond, succession libre. Le 3a est idéal pour optimiser vos impôts, le 3b pour une épargne flexible."
  },
  {
    id: 7,
    question: "Combien puis-je déduire fiscalement avec le 3ème pilier 3a en 2026 ?",
    answer: "En 2026, le montant maximal déductible est de CHF 7'258 pour les salariés affiliés à une caisse de pension (LPP). Pour les indépendants sans 2ème pilier, le montant est de CHF 36'288 ou 20% du revenu net (le plus petit des deux)."
  },
  {
    id: 8,
    question: "Quand puis-je retirer mon 3ème pilier 3a ?",
    answer: "Le retrait ordinaire se fait 5 ans avant l'âge de référence (dès 60 ans pour les hommes, 59-60 ans pour les femmes selon année de naissance) jusqu'à 5 ans après (70 ans maximum). Les retraits anticipés sont possibles pour : achat de votre résidence principale, remboursement hypothèque, départ définitif de Suisse, début d'activité indépendante, ou invalidité totale. Le retrait par tranches (plusieurs comptes 3a) permet d'optimiser la fiscalité."
  },
  
  // FISCALITÉ
  {
    id: 9,
    question: "Comment réduire mes impôts légalement en Suisse ?",
    answer: "Les principales optimisations légales : versement 3ème pilier 3a (CHF 7'258 déductibles), rachats volontaires LPP (déductibles à 100%), frais de garde d'enfants, formation continue professionnelle, frais de déplacement, et déductions pour personnes à charge. À Neuchâtel, une stratégie combinée (3a + rachat LPP) peut réduire votre charge fiscale de CHF 3'000 à CHF 8'000 par an selon votre situation."
  },
  {
    id: 10,
    question: "Qu'est-ce qu'un rachat LPP et combien puis-je économiser ?",
    answer: "Le rachat LPP consiste à combler les lacunes de votre 2ème pilier (années d'études, salaires évolutifs, années à l'étranger). Le montant est 100% déductible fiscalement l'année du versement. Attention : respecter un délai de 3 ans avant le retrait en capital pour conserver l'avantage fiscal."
  },
  {
    id: 11,
    question: "Quelle est la fiscalité du retrait du 3ème pilier ?",
    answer: "Le retrait du 3ème pilier 3a est imposé séparément du revenu, à un taux réduit (entre 3% et 12% selon canton et montant). À Neuchâtel, un retrait de CHF 100'000 est imposé à environ 8-10% (CHF 8'000-10'000). Optimisation : retirer en plusieurs fois (plusieurs comptes 3a) sur plusieurs années pour rester dans les tranches basses."
  },
  
  // RETRAITE & LPP
  {
    id: 12,
    question: "Peut-on prendre sa retraite avant 65 ans en Suisse ?",
    answer: "La rente AVS peut être anticipée au maximum 2 ans avant l'âge de référence, soit dès 63 ans pour les hommes. Pour les femmes, l'âge de référence passe progressivement de 64 à 65 ans d'ici 2028 (dispositions transitoires pour celles nées entre 1961-1969). L'anticipation réduit la rente de 6.8% par année à vie. La retraite anticipée de la caisse de pension (LPP) dépend du règlement de votre institution. Une planification 5-10 ans à l'avance est essentielle pour vérifier la faisabilité financière et calculer vos besoins de capital-pont."
  },
  {
    id: 13,
    question: "Rente ou capital LPP : que choisir à la retraite ?",
    answer: "Rente LPP : revenu mensuel garanti à vie, indexation partielle, rente de conjoint en cas de décès. Capital : montant unique, liberté d'investissement, transmission héritiers facilitée, fiscalité favorable au retrait (taux réduit). Le choix dépend de votre santé, situation familiale, patrimoine, et besoins de liquidité. Une solution mixte (50% rente + 50% capital) est souvent optimale pour combiner sécurité et flexibilité."
  },
  
  // ASSURANCES
  {
    id: 14,
    question: "Quelle assurance maladie complémentaire choisir en Suisse ?",
    answer: "Les complémentaires principales couvrent : hospitalisation privée/semi-privée, médecines alternatives (ostéopathie, homéopathie), soins dentaires, et prestations à l'étranger. Le coût varie selon votre âge, les couvertures choisies et l'assureur. Nous comparons 30+ assureurs suisses pour trouver le meilleur rapport qualité-prix selon vos besoins réels. Conseil clé : souscrire jeune permet généralement de bénéficier de conditions tarifaires avantageuses."
  },
  {
    id: 15,
    question: "Ai-je besoin d'un 3ème pilier ET d'une assurance-vie ?",
    answer: "Non, souvent redondant. Le 3ème pilier 3a inclut déjà une assurance décès/invalidité basique. Une assurance-vie risque pur est utile SI : vous avez des enfants en bas âge, une hypothèque importante, ou un conjoint sans revenus. Nous analysons votre situation pour éviter la surassurance tout en protégeant votre famille."
  },
  
  // HYPOTHÈQUE & IMMOBILIER
  {
    id: 16,
    question: "Quel salaire faut-il pour une hypothèque de 800'000 CHF ?",
    answer: "Règle du tiers : vos charges hypothécaires calculatoires ne doivent pas dépasser 33% de votre revenu brut. Pour CHF 800'000 avec 20% fonds propres (CHF 160'000), vous devez financer CHF 640'000. Calcul : taux 5% + amortissement 1% + entretien 1% = CHF 44'800/an. Salaire minimum requis : CHF 135'000 brut/an. Nous négocions avec 50+ banques pour optimiser votre capacité d'emprunt."
  },
  {
    id: 17,
    question: "Combien de fonds propres pour acheter une maison en Suisse ?",
    answer: "Minimum légal : 20% du prix d'achat, dont au moins 10% en fonds propres durs (épargne, titres). Les 10% restants peuvent provenir du 2ème pilier (LPP) ou 3ème pilier. Exemple : maison CHF 850'000 = CHF 170'000 fonds propres minimum (CHF 85'000 cash + CHF 85'000 piliers possibles). Budget supplémentaire : frais notaire, droits de mutation, taxes (3-5% du prix, soit CHF 25'000-42'000)."
  },
  
  // PME & INDÉPENDANTS
  {
    id: 18,
    question: "Comment optimiser la prévoyance en tant qu'indépendant ?",
    answer: "En tant qu'indépendant sans 2ème pilier obligatoire, optimisez avec : 1) 3ème pilier 3a maximal (CHF 36'288 déductibles en 2026), 2) LPP facultative (déductions + prestations décès/invalidité), 3) 3ème pilier 3b pour flexibilité. Économie fiscale estimée : CHF 10'000-15'000/an à Neuchâtel avec une stratégie complète. Nous créons votre plan personnalisé selon votre revenu et votre situation familiale."
  },
  {
    id: 19,
    question: "Quelle prévoyance professionnelle pour mes employés PME ?",
    answer: "Obligations légales : LPP obligatoire dès CHF 22'680 de salaire (2026). Vous pouvez choisir : plan minimum LPP (cotisations 7-18%), plan sur-obligatoire (meilleures prestations, attractivité employés), ou plan avec options (rachat, retraite flexible). Coût employeur : 50% minimum des cotisations. Nous comparons 20+ fondations pour optimiser coûts/prestations et réduire votre charge administrative."
  }
];

export const contactFormData = {
  themes: [
    "Assurance",
    "Fiscalité", 
    "Retraite",
    "Investissements",
    "Immobilier",
    "PME"
  ],
  timeSlots: [
    "09:00 - 10:00",
    "10:00 - 11:00",
    "11:00 - 12:00", 
    "14:00 - 15:00",
    "15:00 - 16:00",
    "16:00 - 17:00"
  ]
};